import { Icon } from "@iconify/react";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { STATE_COLORS } from "utils/constants";

type Props = {
  type: keyof typeof STATE_COLORS;
  text: string;
};

const icons: Record<
  keyof typeof STATE_COLORS,
  {
    iconName: string;
  }
> = {
  error: {
    iconName: "mi:circle-error",
  },
  warn: {
    iconName: "quill:warning",
  },
  info: {
    iconName: "cuida:info-outline",
  },
  success: {
    iconName: "ep:success-filled",
  },
};

const FullWidthBanner = ({ type = "info", text }: Props) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        width: "100%",
        padding: "1rem 1.2rem .25rem",
      }}
    >
      <Stack
        borderRadius={2}
        direction="row"
        alignItems={"center"}
        gap={1}
        sx={{
          width: "100%",
          padding: ".75rem .75rem",
          fontWeight: 600,
          background: `${STATE_COLORS[type].bgColor}`,
          // margin: "1rem",
        }}
      >
        <Icon icon={icons[type].iconName} style={{ fontSize: "1.25rem" }} />
        <Typography>{text}</Typography>
      </Stack>
    </Stack>
  );
};

export default FullWidthBanner;
